import React from 'react';
import T from 'prop-types';

import Layout from '../../components/layout';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';

interface BlankProps {
  children: React.ReactNode;
}

const Blank: React.FC<BlankProps> = ({ children }) => (
  <>
    <Navbar />
    <Layout>{children}</Layout>
    <Footer />
  </>
);

Blank.propTypes = {
  children: T.node.isRequired,
};

export default Blank;
